import { AlertCircleIcon } from 'lucide-react'

interface ErrorComponentProps {
    message?: string
}
const ErrorComponent = ({ message }: ErrorComponentProps) => {
    return (
        <div className='bg-red-100 border border-red-500 rounded-md px-4 py-2 flex items-center gap-2 justify-center'>
            <AlertCircleIcon className='size-4' />
            <p className='text-sm'>{
                message ? message : 'Something went wrong!'
            }</p>
        </div>
    )
}

export default ErrorComponent